import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody, PanelFooter } from './../../components/panel/panel.jsx';
import Chart from 'chart.js/auto';
import jsVectorMap from 'jsvectormap';
import 'jsvectormap/dist/maps/world.js';
import 'jsvectormap/dist/jsvectormap.min.css';
import Calendar from 'react-calendar';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ApexChart from 'react-apexcharts';
import 'react-calendar/dist/Calendar.css';
import axios from 'axios';
import {API_BASE_URL} from "../../apiConfig.jsx";
import {strEncode,strDecode} from '../../encrpt';

import DataTable from 'react-data-table-component';

function DashboardV1() {
	const navigate = useNavigate();
	const [data, setData] = useState([]);
	const [bedata, setBudgetExecutionData] = useState([]);
	const [brtdata, setBeneficiaryReachTargetData] = useState([]);
	const [tacdata, settimelinessactivitydelayData] = useState([]);
	const [modalheading, setModalHeading] = useState(null);	
	const [indiid, setModalId] = useState(null);	
	const [selectedUser, setSelectedUser] = useState(null);	
	const [modalData, setModalData] = useState([]);
	const [columns, setColumns] = useState([]);
	const [tabledata, settableData] = useState([]);
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");
        //console.log("authToken",authToken)
		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);

	useEffect(() => {
		axios.post(`${API_BASE_URL}/api/custom/selectall`, 
		{ t: strEncode('v_data_progress_rate'),
		   cols : strEncode ("Count(*) as tot,SUM(Valeurcible) as Target , SUM(Réalisation) as Réalisation ,ROUND(((SUM(Réalisation) / SUM(Valeurcible)) * 100), 2) as percent")
	    },
		{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
            //console.log("res",res.data)
            setData(res.data);
          }).catch( (error) => { console.log(error); }); 
		  
		  
		  axios.post(`${API_BASE_URL}/api/custom/selectall`, 
		{ t: strEncode('v_data_beneficiary_reach_target'),
		   cols : strEncode ("Count(*) as tot,SUM(Valeurcible) as Target , SUM(Réalisation) as Réalisation ,ROUND(((SUM(Réalisation) / SUM(Valeurcible)) * 100), 2) as percent")
	    },
		{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
           // console.log("res",res.data)
            setBeneficiaryReachTargetData(res.data);
          }).catch( (error) => { console.log(error); }); 


		  axios.post(`${API_BASE_URL}/api/custom/selectall`, 
		{ t: strEncode('v_data_budget_execution_rate'),
		   cols : strEncode ("Count(*) as tot,SUM(Valeurcible) as Target , SUM(Réalisation) as Réalisation ,ROUND(((SUM(Réalisation) / SUM(Valeurcible)) * 100), 2) as percent")
	    },
		{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
            //console.log("res",res.data)
            setBudgetExecutionData(res.data);
          }).catch( (error) => { console.log(error); }); 


		  axios.post(`${API_BASE_URL}/api/custom/selectall`, 
		{ t: strEncode('v_data_timeliness_activity_completion_delay'),
		   cols : strEncode ("Count(*) as tot,SUM(Valeurcible) as Target , SUM(Réalisation) as Réalisation ,ROUND(((SUM(Réalisation) / SUM(Valeurcible)) * 100), 2) as percent")
	    },
		{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
            //console.log("res",res.data)
            settimelinessactivitydelayData(res.data);
          }).catch( (error) => { console.log(error); }); 
          }, []);

	var redColor = (getComputedStyle(document.body).getPropertyValue('--bs-red')).trim();
	var orangeColor = (getComputedStyle(document.body).getPropertyValue('--bs-orange')).trim();
	var tealColor = (getComputedStyle(document.body).getPropertyValue('--bs-teal')).trim();
	var blueColor = (getComputedStyle(document.body).getPropertyValue('--bs-blue')).trim();
	var gray500Color = (getComputedStyle(document.body).getPropertyValue('--bs-gray-500')).trim();
	var componentColor = (getComputedStyle(document.body).getPropertyValue('--bs-component-color')).trim();
	var red = (getComputedStyle(document.body).getPropertyValue('--bs-red')).trim();
	var orange = (getComputedStyle(document.body).getPropertyValue('--bs-orange')).trim();
	var lime = (getComputedStyle(document.body).getPropertyValue('--bs-lime')).trim();
	var sparkLineOptions = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [redColor]
	};
	var sparkLineOptions2 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [orangeColor]
	};
	var sparkLineOptions3 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [tealColor]
	};
	var sparkLineOptions4 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [blueColor]
	};
	var sparkLineOptions5 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [gray500Color]
	};
	var sparkLineOptions6 = {
		chart: { sparkline: { enabled: true } },
		stroke: { width: 2 },
		colors: [componentColor]
	};
	
	var sparklineData = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData2 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData3 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData4 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData5 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	var sparklineData6 = [{ data: [789, 880, 676, 200, 890, 677, 900] }];
	
	var date = new Date();
	
	var conversionRateChartOptions = {
		chart: {
			type: 'line',
			width: 160,
			height: 28,
			sparkline: { enabled: true }
		},
		stroke: { curve: 'smooth', width: 3 },
		fill: {
			type: 'gradient',
			gradient: {
				opacityFrom: 1,
				opacityTo: 1,
				colorStops: [
				{ offset: 0, color: red, opacity: 1 },
				{ offset: 50, color: orange, opacity: 1 },
				{ offset: 100, color: lime, opacity: 1 }]
			},
		},
		labels: ['Jun 23', 'Jun 24', 'Jun 25', 'Jun 26', 'Jun 27', 'Jun 28', 'Jun 29'],
		xaxis: { crosshairs: { width: 1 } },
		tooltip: {
			theme: 'dark',
			fixed: { enabled: false },
			x: { show: false },
			y: {
				title: { formatter: function (seriesName) { return '' } },
				formatter: (value) => { return value + '%' },
			},
			marker: { show: false }
		},
		responsive: [
			{ breakpoint: 3000, options: { chart: { width: 120 } } },
			{ breakpoint: 1300, options: { chart: { width: 100 } } },
			{ breakpoint: 1200, options: { chart: { width: 160 } } },
			{ breakpoint: 900, options: { chart: { width: 120 } } },
			{ breakpoint: 576, options: { chart: { width: 180 } } },
			{ breakpoint: 400, options: { chart: { width: 120 } } }
		]
	};
	var conversionRateChartSeries = [{
		data: [2.68, 2.93, 2.04, 1.61, 1.88, 1.62, 2.80]
	}];

	var chart;

	var chart1;
	
	function renderChart() {
		var teal = (getComputedStyle(document.body).getPropertyValue('--bs-teal')).trim();
		var tealRgb = (getComputedStyle(document.body).getPropertyValue('--bs-teal-rgb')).trim();
		var blue = (getComputedStyle(document.body).getPropertyValue('--bs-blue')).trim();
		var blueRgb = (getComputedStyle(document.body).getPropertyValue('--bs-blue-rgb')).trim();
		var componentBg = (getComputedStyle(document.body).getPropertyValue('--bs-component-bg')).trim();
		
		var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
		var bodyFontWeight = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight')).trim();
		var bodyColor = (getComputedStyle(document.body).getPropertyValue('--bs-body-color')).trim();
		var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
		
		Chart.defaults.font.family = bodyFontFamily;
		Chart.defaults.font.size = 12;
		Chart.defaults.color = bodyColor;
		Chart.defaults.borderColor = borderColor;
		Chart.defaults.plugins.legend.display = true;
		Chart.defaults.plugins.tooltip.padding = { left: 8, right: 12, top: 8, bottom: 8 };
		Chart.defaults.plugins.tooltip.cornerRadius = 8;
		Chart.defaults.plugins.tooltip.titleMarginBottom = 6;
		Chart.defaults.plugins.tooltip.titleFont.family = bodyFontFamily;
		Chart.defaults.plugins.tooltip.titleFont.weight = bodyFontWeight;
		Chart.defaults.plugins.tooltip.footerFont.family = bodyFontFamily;
		Chart.defaults.plugins.tooltip.displayColors = true;
		Chart.defaults.plugins.tooltip.boxPadding = 6;
		Chart.defaults.scale.grid.color = borderColor;
		Chart.defaults.scale.beginAtZero = true;
		Chart.defaults.maintainAspectRatio = false;
		
		var chart1Container = document.getElementById('chart-1');
		if (chart1) {
			chart1.destroy();
		}
		if (chart1Container) {
			chart1Container.innerHTML = '<canvas id="lineChart"></canvas>';
			chart1 = new Chart(document.getElementById('lineChart'), {
				type: 'line',
				data: {
					labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
					datasets: [{
						label: 'Pages vues',
						fill: false,
						lineTension: 0.1,
						backgroundColor: 'rgba('+ tealRgb +', 0.25)',
						borderColor: teal,
						borderWidth: 2,
						pointBorderColor: teal,
						pointBackgroundColor: componentBg,
						pointBorderWidth: 2,
						pointHoverRadius: 5,
						pointHoverBackgroundColor: componentBg,
						pointHoverBorderColor: teal,
						pointHoverBorderWidth: 3,
						pointRadius: 3,
						pointHitRadius: 10,
						data: [65, 59, 80, 81, 56, 55, 40, 59, 76, 94, 77, 82]
					},{
						label: 'Visiteur',
						fill: false,
						lineTension: 0.1,
						backgroundColor: 'rgba('+ blueRgb +', 0.25)',
						borderColor: blue,
						borderWidth: 2,
						pointBorderColor: blue,
						pointBackgroundColor: componentBg,
						pointBorderWidth: 2,
						pointHoverRadius: 5,
						pointHoverBackgroundColor: componentBg,
						pointHoverBorderColor: blue,
						pointHoverBorderWidth: 3,
						pointRadius: 3,
						pointHitRadius: 10,
						data: [25, 29, 40, 45, 16, 15, 20, 39, 26, 44, 57, 32]
					}]
				}
			});
		}
	}
	
	function renderMap() {
		var componentActiveBg = (getComputedStyle(document.body).getPropertyValue('--bs-component-active-bg')).trim();
		var gray500 = (getComputedStyle(document.body).getPropertyValue('--bs-gray-500')).trim();
		var bodyColor = (getComputedStyle(document.body).getPropertyValue('--bs-body-color')).trim();
		var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
		const map = document.getElementById('jvectorMap');
		const mapElm = document.querySelectorAll('.jvm-tooltip');
		
		if (map) {
			for (let i = 0; i < mapElm.length; i++) {
				mapElm[i].remove();
			}
			map.innerHTML = '';
		
			var markers = [
				{ name: "Egypt", coords: [26.8206, 30.8025] },
				{ name: "Russia", coords: [61.524, 105.3188] },
				{ name: "Canada", coords: [56.1304, -106.3468] },
				{ name: "Greenland", coords: [71.7069, -42.6043] },
				{ name: "Brazil", coords: [-14.235, -51.9253] }
			];
			new jsVectorMap({
				selector: '#jvectorMap',
				map: 'world',
				zoomButtons: true,
				normalizeFunction: 'polynomial',
				hoverOpacity: 0.5,
				hoverColor: false,
				zoomOnScroll: false,
				series: {
					regions: [{
						normalizeFunction: 'polynomial'
					}]
				},
				labels: {
					markers: {
						render: (marker) => marker.name
					}
				},
				focusOn: {
					x: 0.5,
					y: 0.5,
					scale: 1
				},
				markers: markers,
				markerStyle: {
					initial: {
						fill: componentActiveBg,
						stroke: 'none',
						r: 5,
					},
					hover: {
						fill: componentActiveBg
					}
				},
				markerLabelStyle: {
					initial: {
						fontFamily: bodyFontFamily,
						fontSize: '12px',
						fill: bodyColor
					},
				},
				regionStyle: {
					initial: {
						fill: gray500,
						fillOpacity: 0.5,
						stroke: 'none',
						strokeWidth: 0.4,
						strokeOpacity: 1
					},
					hover: {
						fillOpacity: 0.5
					}
				},
				backgroundColor: 'transparent',
			});
		}
	}
	
	const handleModalOpen = async (user,table,modaltitle) => {
		//console.log("user.id",user.id)
		setSelectedUser(user);	
		setModalId(user.id)
		setModalHeading(modaltitle)
		axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode(table),cols:strEncode('activités as `activités`, Valeurintermédiaire  as  `Valeurintermédiaire`,Valeurcible as `Valeurcible`,Réalisation as `Réalisation`, Date(latest_entry) as `Date de déclaration`') },{ headers: { 'Content-Type': 'application/json' } }) 
		.then( (res) => {					
		  if (!res.data || !res.data || res.data.length === 0) {
			  console.warn("Warning: API returned an empty or undefined response.");
			  setColumns([]); // Reset columns
			  settableData([]); // Reset table data
			  return;
		  }
		  const columnKeys = Object.keys(res.data[0]);
		  
		  const formattedColumns = columnKeys.map((key) => ({
			  name: key.charAt(0).toUpperCase() + key.slice(1),
			  selector: row => row[key],
			  sortable: true,
			  cell: row => row[key] // Show normal column data
			}));			
		  //console.log("columnKeys",columnKeys)
		  setColumns(formattedColumns);
		  settableData(res.data);					
		}).catch(error => {
		  console.error("API Error:", error);
		});
	  
	  };
	


	useEffect(() => {
    // eslint-diable-next-line
    renderMap();
		renderChart();
		
		document.addEventListener('theme-reload', () => {
			renderMap();
			renderChart();
		});
		
		// eslint-disable-next-line
	}, []);
	
	const closeModal = () => {
		setModalData([]);
	   }
	
	return (
		<>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">Domicile</Link></li>
				<li className="breadcrumb-item active">Tableau de bord</li>
			</ol>
			<h1 className="page-header">Tableau de bord du Projet sur la Gouvernance locale et la Résilience communautaire (KPENGBA).</h1>
			
			<div className="row">
				<div className="col-xl-6 col-md-6">
				{data.map((item) => (
					<div className="widget widget-stats bg-blue">
						<div className="stats-icon"><i className="fa fa-line-chart"></i></div>
						
						<div className="stats-info">
							<h3>Taux d'avancement de la mise en œuvre (%)</h3>
							
								<div className="card-body">
								<div className="d-flex align-items-center mb-1">
									<h2 className="text-white mb-0">{item.percent}%</h2>
								
								</div>
								{/* <div className="mb-4 text-gray-500 ">
									<i className="fa fa-caret-down"></i> 0.50% compare to last week
								</div> */}
								<div className="d-flex mb-2">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-red fs-8px me-2"></i>
										Nombre total d'activité									</div>
									<div className="d-flex align-items-center ms-auto">
									<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}> {item.tot}</span>
									</div>
								</div>
								<div className="d-flex mb-2">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-red fs-8px me-2"></i>
										Valeur cible
									</div>
									<div className="d-flex align-items-right ms-auto">
										<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.Target}</span>
									</div>
								</div>
								
								<div className="d-flex">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-lime fs-8px me-2"></i>
										Réalisation 
									</div>
									<div className="d-flex align-items-center ms-auto">											
									<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.Réalisation}</span>
									</div>
								</div>
							</div> 
						</div>
						
						<div className="stats-link">
							<Link to="/dashboard/v1" data-bs-toggle="modal"
											data-bs-target="#modalPosBooking"
											onClick={() => handleModalOpen(item,'v_data_progress_rate',`Taux d'avancement de la mise en œuvre`)}>Voir les détails <i className="fa fa-arrow-alt-circle-right"></i></Link>
						</div>
						
					</div>
					))}
			

				</div>
				<div className="col-xl-6 col-md-6">
				{brtdata.map((item) => (
					<div className="widget widget-stats bg-info">
						<div className="stats-icon"><i className="fa fa-users"></i></div>
						
						<div className="stats-info">
							<h3>Portée des bénéficiaires par rapport à la cible (%)</h3>
							
								<div className="card-body">
								<div className="d-flex align-items-center mb-1">
									<h2 className="text-white mb-0">{item.percent}%</h2>
								
								</div>
								{/* <div className="mb-4 text-gray-500 ">
									<i className="fa fa-caret-down"></i> 0.50% compare to last week
								</div> */}
								<div className="d-flex mb-2">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-red fs-8px me-2"></i>
										Nombre total d'activité									</div>
									<div className="d-flex align-items-center ms-auto">
									<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.tot}</span>
									</div>
								</div>
								<div className="d-flex mb-2">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-red fs-8px me-2"></i>
										Valeur cible
									</div>
									<div className="d-flex align-items-right ms-auto">
										<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.Target}</span>
									</div>
								</div>
								
								<div className="d-flex">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-lime fs-8px me-2"></i>
										Réalisation 
									</div>
									<div className="d-flex align-items-center ms-auto">											
									<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.Réalisation}</span>
									</div>
								</div>
							</div> 
								
							
						</div>
						<div className="stats-link">
							<Link to="/dashboard/v1" data-bs-toggle="modal"
											data-bs-target="#modalPosBooking"
											onClick={() => handleModalOpen(item,'v_data_beneficiary_reach_target','Portée des bénéficiaires par rapport à la cible')}>Voir les détails <i className="fa fa-arrow-alt-circle-right"></i></Link>
						</div>
						
					</div>
					))}
				</div>
				<div className="col-xl-6 col-md-6">
				{bedata.map((item) => (
					<div className="widget widget-stats bg-orange">
						<div className="stats-icon"><i className="fa fa-dollar"></i></div>
						
						<div className="stats-info">
							<h3>Taux d'exécution du budget (%)</h3>
							
								<div className="card-body">
								<div className="d-flex align-items-center mb-1">
									<h2 className="text-white mb-0">{item.percent}%</h2>
								
								</div>
								{/* <div className="mb-4 text-gray-500 ">
									<i className="fa fa-caret-down"></i> 0.50% compare to last week
								</div> */}
								<div className="d-flex mb-2">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-red fs-8px me-2"></i>
										Nombre total d'activité									</div>
									<div className="d-flex align-items-center ms-auto">
									<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.tot}</span>
									</div>
								</div>
								<div className="d-flex mb-2">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-red fs-8px me-2"></i>
										Valeur cible
									</div>
									<div className="d-flex align-items-right ms-auto">
										<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.Target}</span>
									</div>
								</div>
								
								<div className="d-flex">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-lime fs-8px me-2"></i>
										Réalisation 
									</div>
									<div className="d-flex align-items-center ms-auto">											
									<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.Réalisation}</span>
									</div>
								</div>
							</div> 
								
							
						</div>
						<div className="stats-link">
							<Link to="/dashboard/v1" data-bs-toggle="modal"
											data-bs-target="#modalPosBooking"
											onClick={() => handleModalOpen(item,'v_data_budget_execution_rate',`Taux d'exécution du budget`)}>Voir les détails <i className="fa fa-arrow-alt-circle-right"></i></Link>
						</div>
						
					</div>
					))}
				</div>
				<div className="col-xl-6 col-md-6">
				{tacdata.map((item) => (
					<div className="widget widget-stats bg-red">
						<div className="stats-icon"><i className="fa fa-bar-chart"></i></div>
						
						<div className="stats-info">
							<h3>Ponctualité / Retard d'achèvement des activités (en jours ou en % de retard sur le calendrier)</h3>
							
								<div className="card-body">
								<div className="d-flex align-items-center mb-1">
									<h2 className="text-white mb-0">{item.percent}%</h2>
								
								</div>
								{/* <div className="mb-4 text-gray-500 ">
									<i className="fa fa-caret-down"></i> 0.50% compare to last week
								</div> */}
								<div className="d-flex mb-2">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-red fs-8px me-2"></i>
										Nombre total d'activité									</div>
									<div className="d-flex align-items-center ms-auto">
									<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.tot}</span>
									</div>
								</div>
								<div className="d-flex mb-2">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-red fs-8px me-2"></i>
										Valeur cible
									</div>
									<div className="d-flex align-items-right ms-auto">
										<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.Target}</span>
									</div>
								</div>
								
								<div className="d-flex">
									<div className="d-flex align-items-center fs-15px">
										<i className="fa fa-circle text-lime fs-8px me-2"></i>
										Réalisation 
									</div>
									<div className="d-flex align-items-center ms-auto">											
									<span className="badge bg-inverse rounded-0" style={{fontSize:"1.2em"}}>  {item.Réalisation}</span>
									</div>
								</div>
							</div> 
								
							
						</div>
						<div className="stats-link">
							<Link to="/dashboard/v1" data-bs-toggle="modal"
											data-bs-target="#modalPosBooking"
											onClick={() => handleModalOpen(item,'v_data_timeliness_activity_completion_delay',`Ponctualité / Retard d'achèvement des activité`)}>Voir les détails <i className="fa fa-arrow-alt-circle-right"></i></Link>
						</div>
						
					</div>
					))}
				</div>
			</div>

			
					
					
				



			<div className="row">
				<div className="col-xl-8">
					<Panel>
						<PanelHeader>Nombre de décrets d'application, de recueils et de documents de vulgarisation produits</PanelHeader>
						<PanelBody>
							<div id="chart-1" className="h-300px"></div>
						</PanelBody>
					</Panel>
			
				</div>
				<div className="col-xl-4">
					<Panel>
						<PanelHeader>Valeur intermédiaire</PanelHeader>
						<PanelBody className="p-0">
							<div className="table-responsive">
								<table className="table table-panel align-middle mb-0">
									<thead>
										<tr>	
											<th>Indicateurs</th>
											<th>Valeur intermédiaire</th>
											<th>Valeur cible</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td><label className="badge bg-danger">Visiteur unique</label></td>
											<td>13,203 <span className="text-success"><i className="fa fa-arrow-up"></i></span></td>
											<td className="align-middle">
												<div className="w-100px my-n1">
													<ApexChart type="line" height="20" options={sparkLineOptions} series={sparklineData} />
												</div>
											</td>
										</tr>
										<tr>
											<td><label className="badge bg-warning">Taux de rebond</label></td>
											<td>28.2%</td>
											<td className="align-middle">
												<div className="w-100px my-n1">
													<ApexChart type="line" height="20" options={sparkLineOptions2} series={sparklineData2} />
												</div>
											</td>
										</tr>
										<tr>
											<td><label className="badge bg-success">Nombre total de pages vues</label></td>
											<td>1,230,030</td>
											<td className="align-middle">
												<div className="w-100px my-n1">
													<ApexChart type="line" height="20" options={sparkLineOptions3} series={sparklineData3} />
												</div>
											</td>
										</tr>
										<tr>
											<td><label className="badge bg-blue">Temps moyen sur place</label></td>
											<td>00:03:45</td>
											<td className="align-middle">
												<div className="w-100px my-n1">
													<ApexChart type="line" height="20" options={sparkLineOptions4} series={sparklineData4} />
												</div>
											</td>
										</tr>
										<tr>
											<td><label className="badge bg-gray-500">% Nouvelles visites</label></td>
											<td>40.5%</td>
											<td className="align-middle">
												<div className="w-100px my-n1">
													<ApexChart type="line" height="20" options={sparkLineOptions5} series={sparklineData5} />
												</div>
											</td>
										</tr>
										<tr>
											<td><label className="badge bg-inverse">Visiteurs de retour</label></td>
											<td>73.4%</td>
											<td className="align-middle">
												<div className="w-100px my-n1">
													<ApexChart type="line" height="20" options={sparkLineOptions6} series={sparklineData6} />
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</PanelBody>
					</Panel>		
					
				</div>
			</div>

			<div className="modal modal-pos fade" id="modalPosBooking">
				<div className="modal-dialog modal-lg" style={{maxWidth:"95%"}}>
					<div className="modal-content border-0">
						<div>
							<div className="p-0">
														
    <div className="modal-body">
        <div className="d-flex align-items-center mb-3">
            <h4 className="modal-title d-flex align-items-center">
                <i className="fa fa-bowl-rice fs-2 me-2 my-n1"></i> {modalheading}
            </h4>
            <a href="/#" data-bs-dismiss="modal" onClick={closeModal} className="ms-auto btn-close">&nbsp;</a>
        </div>
        <div className="row">
            <div className="row mb-15px">
                                                  <DataTable
									title=""
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>
               
            </div>
        </div>
    </div>
    <div className="modal-footer">									
       
    </div>



							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
};

export default DashboardV1;